import MuiAccordionSummary, {
  accordionSummaryClasses,
} from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import { styled } from '@mui/material/styles'
export { SimpleAccordion as Accordion } from '@sales-center/components'

export const AccordionSummary = styled(MuiAccordionSummary)(({ theme }) => ({
  minHeight: 'unset',
  borderTop: `1px solid ${theme.palette.divider}`,
  backgroundColor: 'inherit',
  transition: 'border-color 0.25s ease',
  borderRadius: 4,
  [`&.${accordionSummaryClasses.expanded}`]: {
    boxShadow: '0px 2px 6px 0px #C2C2C280',
    borderColor: theme.palette.background.paper,
    minHeight: 'unset',
  },

  [`& .${accordionSummaryClasses.content}`]: {
    margin: '0',
    [`&.${accordionSummaryClasses.expanded}`]: {
      margin: '0',
    },
  },
  expanded: {},
}))

export const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  flexDirection: 'column',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  '& > div:not(:last-child)': {
    marginBottom: theme.spacing(2),
  },
}))
